// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3iB0_","label":"Completed_label__1SShh"};